import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import {retry} from 'rxjs/operators';
import {ConstantsService} from './constants.service';
import {UtilsService} from './utils.service';
import { SessionsService } from './sessions.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class HttpserviceService { 

  private deviceInfo = {};
  private ipAddress:string ="";

  constructor(private http: HttpClient,private _constant: ConstantsService,private  utilsService:UtilsService,
  private sessionsService:SessionsService,private deviceDetectorService: DeviceDetectorService) 
  { 
    this.epicFunction();
    this.getIPAddress();
  }

   
  epicFunction() {
      console.log('hello `Home` component');
      this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
      console.log(this.deviceInfo);      
    }

  /** getIPAddress function used to get user ip address */
  getIPAddress()
  {

    this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{      
      this.ipAddress = res.ip;
      console.log(this.ipAddress);
    });  
  } 

  /** headerAuthRequest fuction used to send header auth request */ 
  headerAuthRequest()
  {
    this.http.get(this._constant.httpServicesUrl+'HeaderAuth').
    pipe(retry(0)).
    subscribe((data)=>this.utilsService.headerAuthResponse(data),
     err => {
        console.log('Something went wrong ', err);
    }) 
  }

  /** sendRegOtpOnMobileNo function used to send otp on mobile no */
  sendRegOtpOnMobileNo(mobileNumber:string)
  { 
 this.sessionsService.setSession('mobile_no',mobileNumber);   
 let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });
 let body = {mobile_number:mobileNumber,ip_address:this.ipAddress,device_mac_detail:this.deviceInfo}
     return this.http.post(this._constant.httpServicesUrl+"LoginMobile",body,{headers}) 
  }

  
/** confirmRegOtpOnMobileNo function used to confirm otp on mobile no */
  confirmRegOtpOnMobileNo(otp:string)
  {  
 let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
 let body = {mobile_number:this.sessionsService.getSession('mobile_no'), otp:otp };
     return this.http.post(this._constant.httpServicesUrl+"VerifyMobile",body,{headers})
  }

  /** registrationRequest function used to send registration request */
  registrationRequest(formdata:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"DealerSignup",formdata,{headers})
  }

  /** credentialsLoginRequest function used to send login with credentials request */
  credentialsLoginRequest(user:string,password:string)
  {  
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    let body = {email_id:user, password:btoa(password) };
     return this.http.post(this._constant.httpServicesUrl+"LoginCredentials",body,{headers})
  }

  /** sendLoginOtpOnMobileNoRequest function used to send request of login otp on mobile no. */
  sendLoginOtpOnMobileNoRequest(mobileNumber:string)
  { 
 let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });
 let body = {mobile_number:mobileNumber,type:"login_request"}
 return this.http.post(this._constant.httpServicesUrl+"LoginMobile",body,{headers}) 
  }

  /** confirmLoginOtpOnMobileRequest function used to confirm login otp on mobile no */
  confirmLoginOtpOnMobileRequest(mobile_number:string,otp:string)
  {  
 let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
 let body = {mobile_number:mobile_number, otp:otp };
     return this.http.post(this._constant.httpServicesUrl+"LoginOtpVerify",body,{headers})
  }

  /** carUploadRequest function used to send car upload request */
  carUploadRequest(formdata:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"UploadCarDetail",formdata,{headers})
  }

  /** confirmRegOtpOnMobileNo2 function used to confirm otp on mobile no */
  confirmRegOtpOnMobileNo2(mobileNo:string,otp:string)
  {  
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
     let body = {mobile_number:mobileNo, otp:otp };
     return this.http.post(this._constant.httpServicesUrl+"VerifyMobile",body,{headers})
  }

  /** contactUsRequest function used to save contact us detail */
  contactUsRequest(name:string,email:string,message:string,mobileNo:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = {name:name, email:email,message:message,status:"0",mobile:mobileNo };
  return this.http.post(this._constant.httpServicesUrl+"ContactusSave",body,{headers})
  }

  /** carListRequest function used to get car list */
  carListRequest(profile_id:string,type:string,count:string,filter_by:any,sort_by:any,search_by:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: profile_id, type: type, count: count, filter_by: filter_by, sort_by:  sort_by, search_by: search_by};
  return this.http.post(this._constant.httpServicesUrl+"CarList",body,{headers})
  }
 
  /** carDetailRequest function used to get car detail */
  carDetailRequest(id:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = {profile_id: this.sessionsService.getSession('id'), id: id};  
  return this.http.post(this._constant.httpServicesUrl+"CarDetail",body,{headers})
  }

  /** completeRegistrationRequest function used to send complete registration request */
  completeRegistrationRequest(formdata:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"DealerUpdate",formdata,{headers})
  }

  /** myCarListRequest function used to get my car list */
  myCarListRequest(type:string,count:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),type:type,count:count};
  return this.http.post(this._constant.httpServicesUrl+"MyCars",body,{headers})
  }

  /** updateProfilePicRequest function used to send update profile pic request */
  updateProfilePicRequest(formdata:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"UpdateMyProfilePic",formdata,{headers})
  }

  /** profileDetailUpdateRequest function used to send profile detail update request */
  profileDetailUpdateRequest(first_name:string,last_name:string,contact_person_name:string,contact_person_number:string,company_name:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  let body = { profile_id: this.sessionsService.getSession('id'),first_name:first_name,last_name:last_name,contact_person_name:contact_person_name,contact_person_number:contact_person_number,company_name:company_name};
  return this.http.post(this._constant.httpServicesUrl+"UpdateMyProfile",body,{headers})
  }

  /** getProfileDetailRequest function used to get profile detail */
  getProfileDetailRequest()
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"DealerDetails",body,{headers})
  }

  /** kycDetailUpdateRequest function used to send kyc detail update request */
  kycDetailUpdateRequest(formdata:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
    return this.http.post(this._constant.httpServicesUrl+"UpdateMyKyc",formdata,{headers})
  }

  /** changePasswordRequest function used to send change password request */
  changePasswordRequest(oldPassword:string,newPassword:string)
  {  
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  let body = { profile_id: this.sessionsService.getSession('id'),old_password:btoa(oldPassword),password:btoa(newPassword)};
  return this.http.post(this._constant.httpServicesUrl+"UpdateMyPassword",body,{headers})
  }

  creditCardRequest(creditCardName:string,creditCardNo:string,creditCardMonth:string,creditCardYear:string)
  {
     let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),credit_card_holder_name:creditCardName,credit_card_number:creditCardNo,credit_card_expiration:creditCardMonth+"-"+creditCardYear};
  return this.http.post(this._constant.httpServicesUrl+"UpdateMyCreditDetails",body,{headers})
  }

  debitCardRequest(debitCardName:string,debitCardNo:string,debitCardMonth:string,debitCardYear:string)
  {    
     let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),debit_holder_name:debitCardName,debit_card_number:debitCardNo,expiration:debitCardMonth+"-"+debitCardYear};
  return this.http.post(this._constant.httpServicesUrl+"UpdateMyDebitDetails",body,{headers})
  }

  bankDetailSaveRequest(formData:FormData)
  {
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"UpdateMyBankDetails",formData,{headers})
  }

  addressSaveRequest(addressDetail:string,addressState:string,addressCity:string,addressPincode:string)
  {
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),address:addressDetail,state:addressState,city:addressCity,pincode:addressPincode};
  return this.http.post(this._constant.httpServicesUrl+"AddAddress",body,{headers})
  }

  getAddressListRequest()
  {
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"ListAddress",body,{headers})
  }

  removeAddressRequest(id:string)
  {
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),address_id:id};
  return this.http.post(this._constant.httpServicesUrl+"RemoveAddress",body,{headers})
  }

  getStateListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetState",body,{headers})
  }

  getStateCityListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetStateCity",body,{headers})
  }

  getAllStateListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllStates",body,{headers})
  }

  getAllCityListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllCities",body,{headers})
  }

  getBrandListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetBrand",body,{headers})
  }

  getBrandModelListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetBrandModel",body,{headers})
  }

  getModelVariantListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetModelVariant",body,{headers})
  }
  getAllBrandListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllBrands",body,{headers})
  }
  getAllModelListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllModels",body,{headers})
  }
  getAllVariantListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllVariants",body,{headers})
  }
  getFuelTypeListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetFuelType",body,{headers})
  }
  SavePreferenceRequest(prefStates:string,prefPriceRangeFrom:string,prefPriceRangeTo:string,selectedBrandIds:string,
  selectedSegmentIds:string)
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),state:prefStates,range_from:prefPriceRangeFrom,range_to:prefPriceRangeTo,brand:selectedBrandIds,segment:selectedSegmentIds};
  return this.http.post(this._constant.httpServicesUrl+"UserRequirement",body,{headers})
  }   
  getPreferenceRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetUserRequirement",body,{headers})
  } 
  /** confirmRegOtpOnMobileNo2 function used to confirm otp on mobile no */
  confirmRegOtpOnMobileNo3(mobileNo:string,otp:string,type:string)
  {  
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
     let body = {mobile_number:mobileNo, otp:otp, type:type };
     return this.http.post(this._constant.httpServicesUrl+"VerifyMobile",body,{headers})
  }
  getAllTypeListRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AllFields",body,{headers})
  }

  getBrandWithCountRequest(type:any)
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),type:type};
  return this.http.post(this._constant.httpServicesUrl+"AllBrandCount",body,{headers})
  }

   getCarBodyTypeRequest()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"GetBodyStyle",body,{headers})
  }

   getBrandListRequest2()
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AdminBrandList",body,{headers})
  }

  addCarInFavoriteRequest(carId:string)
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),car_id:carId};
  return this.http.post(this._constant.httpServicesUrl+"AddFavCar",body,{headers})
  }

  getFavoriteCarsListRequest(type:string,count:string)
  {
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'), type: type,count: count};
  return this.http.post(this._constant.httpServicesUrl+"ListAllFavCar",body,{headers})
  }

  addressUpdateRequest(addressDetail:string,addressState:string,addressCity:string,addressPincode:string)
  {
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'),address:addressDetail,state_id:addressState,city_id:addressCity,pin_code:addressPincode};
  return this.http.post(this._constant.httpServicesUrl+"AddAddress",body,{headers})
  }

  /** carListCountRequest function used to get car list */
  carListCountRequest(profile_id:string,type:string,count:string,filter_by:any,sort_by:any,search_by:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: profile_id, type: type, count: count, filter_by: filter_by, sort_by:  sort_by, search_by: search_by};
  return this.http.post(this._constant.httpServicesUrl+"CarListCount",body,{headers})
  }

 /** adminTestimonialListRequest function used to get testimonial list */
  adminTestimonialListRequest()
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"AdminTestimonialList",body,{headers})
  }

  /** getFavoriteCarListCountRequest function used to get favorite car list count */
  getFavoriteCarListCountRequest(type:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'), type: type};
  return this.http.post(this._constant.httpServicesUrl+"ListAllFavCarCount",body,{headers})
  }

  /** myCarsListCountRequest function used to get car list count */
  myCarsListCountRequest(type:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'), type: type};
  return this.http.post(this._constant.httpServicesUrl+"MyCarListCount",body,{headers})
  }

  /** myFavCarsListCountRequest function used to get favorite car list count */
  myFavCarsListCountRequest(type:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'), type: type};
  return this.http.post(this._constant.httpServicesUrl+"CountAllFavCar",body,{headers})
  }

  /** myInspectionCarsListRequest function used to get my inspection cars list count */
  myInspectionCarsListRequest()
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"MyEvaluations",body,{headers})
  }

  /** saveInspectionBasicInfoRequest method used to save basic detail of inspection */
  saveInspectionBasicInfoRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertBasicInformationInspection",body,{headers})
  }

  /** saveInspectionDocDetailRequest method used to save documents detail of inspection */
  saveInspectionDocDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertDocumentInspection",body,{headers})
  }

  /** saveExteriorDetailRequest method used to save exterior detail of inspection */
  saveExteriorDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"UpdateInspectionExteriorFront",formData,{headers})
  }

  /** saveEngineDetailRequest method used to save engine detail of inspection */
  saveEngineDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertEngineTransmissionInspection",formData,{headers})
  }

  /** saveAcDetailRequest method used to save ac detail of inspection */
  saveAcDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertACInspection",formData,{headers})
  }

  /** saveInteriorDetailRequest method used to save interior detail of inspection */
  saveInteriorDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertCarInteriorInspection",formData,{headers})
  }

  /** saveSsbDetailRequest method used to save steering,suspension and brakes detail of inspection */
  saveSsbDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertSSBInspection",formData,{headers})
  }

  /** saveRatingDetailRequest method used to save rating detail of inspection */
  saveRatingDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"UpdateInspectionCarRating",body,{headers})
  }

  /** getInspectionDetailRequest method used to get detail of inspection */
  getInspectionDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"GetInspectionDetails",body,{headers})
  }

  /** saveExteriorOtherDetailRequest method used to save exterior other detail of inspection */
  saveExteriorOtherDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"UpdateInspectionExteriorOthers",formData,{headers})
  }

  /** saveExteriorTyresDetailRequest method used to save exterior tyres detail of inspection */
  saveExteriorTyresDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"UpdateInspectionTyres",formData,{headers})
  }
  /** saveOtherInspectionDetailRequest method used to save other inspection detail of inspection */
  saveOtherInspectionDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"UpdateInspectionOtherDetails",formData,{headers})
  }

  /** saveDocumentDetailRequest method used to save document detail of inspection */
  saveDocumentDetailRequest(formData:FormData)
  {  
  let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"InsertDocumentInspection",formData,{headers})
  }

  /** loadExteriorFrontXMLRequest function used to get exterior front xml */
  loadExteriorFrontXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/exterior-front.xml",{responseType: 'text'})
  }

  /** loadExteriorOtherXMLRequest function used to get exterior other xml */
  loadExteriorOtherXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/exterior-other.xml",{responseType: 'text'})
  }
  
  /** loadTyresXMLRequest function used to get tyres xml */
  loadTyresXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/tyres.xml",{responseType: 'text'})
  }

  /** loadTyresXMLRequest function used to get tyres xml */
  loadEngineXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/engine.xml",{responseType: 'text'})
  }

  /** loadInteriorXMLRequest function used to get interior xml */
  loadInteriorXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/interior.xml",{responseType: 'text'})
  }
  /** loadACXMLRequest function used to get ac xml */
  loadACXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/ac.xml",{responseType: 'text'})
  }
  /** loadSSBXMLRequest function used to get ac xml */
  loadSSBXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/ssb.xml",{responseType: 'text'})
  }
  /** loadDocumentXMLRequest function used to get ac xml */
  loadDocumentXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/document.xml",{responseType: 'text'})
  }

  /** loadCoolingSystemXMLRequest function used to get tyres xml */
  loadCoolingSystemXMLRequest()
  {
    return this.http.get(this._constant.uploadFileUrl+"uploads/xml/coolingsystem.xml",{responseType: 'text'})
  }
  /** saveDocumentDetailRequest method used to save document detail of inspection */
  saveCoolingSystembDetailRequest(formData:FormData)
  {  
    let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    return this.http.post(this._constant.httpServicesUrl+"InsertCoolingSystemInspection",formData,{headers})
  } 

  /** changePasswordLinkRequest method used to send password reset link */
  changePasswordLinkRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"ForgotPassword",body,{headers})
  }

  /** saveBidDetailRequest method used to save bid detail */
  saveBidDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });    
  return this.http.post(this._constant.httpServicesUrl+"SaveBidDetails",body,{headers})
  }

  /** saveJoinOkshanDetailRequest method used to save join okshan detail */
  saveJoinOkshanDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  return this.http.post(this._constant.httpServicesUrl+"SaveJoinOkshanPayment",body,{headers})
  }

  /** getOkshanLiveLinkDetail function used to get okshan live link detail */
  getOkshanLiveLinkDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"ViewLiveOkshanDetails",body,{headers})
  }


  /** getOkshanLiveLinkDetail function used to get okshan live link detail */
  getFPSLiveLinkDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"ViewLiveFpsDetails",body,{headers})
  }


  /** saveBuyNowPaymentRequest method used to save buy now payment */
  saveBuyNowPaymentRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  return this.http.post(this._constant.httpServicesUrl+"SaveBuyNowPayment",body,{headers})
  }

  /** saveMakeAnOfferPaymentRequest method used to save make an offer payment */
  saveMakeAnOfferPaymentRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('email_id'), 'password': this.sessionsService.getSession('password') });   
  return this.http.post(this._constant.httpServicesUrl+"SaveBuyNowMakeOffer",body,{headers})
  }  

  /** getMyPaymentDetailRequest function used to get my payment detail */
  getMyPaymentDetailRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"CheckMyWallet",body,{headers})
  }

   /** getKycStatusRequest function used to get kyc status */
  getKycStatusRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"CheckKycStatus",body,{headers})
  }

  /** sendChangePasswordOtpRequest2 function used to send change password otp request */
  sendChangePasswordOtpRequest2(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"SendPasswordRequest",body,{headers})
  }

  /** changePasswordWithMobileOtpRequest function used to send change password otp request */
  changePasswordWithMobileOtpRequest(body:any)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  return this.http.post(this._constant.httpServicesUrl+"VerifyPasswordRequest",body,{headers})
  }
  
  deleteCarpicRequest(pic:string,id:string)
  { 
 let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });
 let body = {pic:pic,car_id:id}
     return this.http.post(this._constant.httpServicesUrl+"RemoveCarPic",body,{headers}) 
  } 
  
  editCarpicRequest(formdata:FormData)
  { 
 let headers = new HttpHeaders({'username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });
     return this.http.post(this._constant.httpServicesUrl+"EditCarPic",formdata,{headers}) 
  } 

  /** myInspectionCarsListRequest function used to get my inspection cars list count */
  makeOfferListRequest(id:string)
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id'), car_id: id};
  return this.http.post(this._constant.httpServicesUrl+"ListMakeOffer",body,{headers})
  }
  /** myAppCarListRequest function used to get my car list */
  myAppCarListRequest()
  {  
  let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
  let body = { profile_id: this.sessionsService.getSession('id')};
  return this.http.post(this._constant.httpServicesUrl+"MyAppCarList1",body,{headers})
  }

  getAcceptOfferCarsRequest(id:string, profile_id:string, accept_value:string)
  {
    let headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*','username': this.sessionsService.getSession('auth_user'), 'password': this.sessionsService.getSession('auth_pass') });   
    let body = { profile_id:profile_id, car_id: id, accept_value: accept_value};
    return this.http.post(this._constant.httpServicesUrl+"AcceptOfferCars",body,{headers})
  }

}


